import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/pr1.jpg";
import projImg2 from "../assets/img/pr2.jpg";
import projImg3 from "../assets/img/pr3.jpg";
import projImg4 from "../assets/img/pr4.jpg";
import projImg5 from "../assets/img/pr5.jpg";
import projImg6 from "../assets/img/pr6.jpg";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Outen Auto Centre",
      description: "We’re thrilled with the results from our digital marketing agency over the past two months: an 80% increase in followers and a 25% boost in leads. Their strategic approach, engaging content, and consistent brand messaging have transformed our online presence. We couldn't be happier and look forward to continued growth!",
      imgUrl: projImg1,
    },
    {
      title: "Bakery Lorraine",
      description: "Working with Samsha has been fantastic for Bakery Lorraine. Their design expertise and strategic insights have captured our essence, elevating our brand and building a loyal customer base. The results have exceeded our expectations, and we look forward to continuing this partnership!",
      imgUrl: projImg5,
    },
    {
      title: "Bunty Pet Products ",
      description: "Working with Samsha has been outstanding. Their customized social media and SEO approach has enhanced our online presence and engagement. Creative content, strategic execution, and SEO have grown our follower base, rankings, and customer connections. We're impressed with the results and look forward to continued success!",
      imgUrl: projImg3,
    },
    {
      title: "St Kate:- The Arts Hotel",
      description: "Samsha's innovative strategies have transformed Saint Kate, capturing our brand, attracting guests, and strengthening ties with the arts community. Thrilled with the results!",
      imgUrl: projImg4,
    },
    {
      title: "Eve Bombay",
      description: "Partnering with Samsha has truly elevated Eve Bombay’s digital presence to new heights. Their mastery in crafting visually stunning content, combined with a strategic and data-driven approach, has significantly enhanced our brand’s allure and reach. Within just three months, Samsha has helped us generate amazing leads and created a spectacular brand image, making our restaurant well-known and highly regarded. The impeccable execution and remarkable outcomes have far exceeded our expectations, and we look forward to continuing this exceptional collaboration.",
      imgUrl: projImg6,
    },
    {
      title: "Definitive Healthcare ",
      description: "Samsha boosted DHC People's visibility and generated over $50,000 in new business. Exceptional value for business!",
      imgUrl: projImg2,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Our Clients</h2>
                <p>With Samsha Marketing, you’ll not only rank higher but also grow your brand authentically and sustainably in a competitive digital landscape.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Tab 1</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab 2</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Tab 3</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <p> At Samsha, We provide a comprehensive technical audit of your website, highlighting SEO performance, technical issues, and areas for improvement. With a detailed analysis, we uncover growth opportunities and develop a personalized roadmap to boost your online presence.</p> <p>Furthermore, our expert team works closely with you to optimize your site and achieve higher rankings on search engine results pages (SERPs). Using a data-driven approach, we tailor every SEO action—whether content optimization or technical refinement—to fit your brand identity and enhance your digital footprint.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Our deep-dive competitor research identifies your target keywords, analyzes site structures, and tracks backlinks to help you outperform your competition. We gain the edge by understanding your competitors' strengths and exploiting their weaknesses, positioning your brand ahead in search results.</p>
                      <p>Our SEO specialists implement high-quality backlink strategies that build site authority and enhance credibility. From strategic guest posts to link exchanges, we boost your organic traffic and open new revenue opportunities by increasing your website's visibility. By leveraging competitor insights and building powerful backlinks, we give your brand a competitive advantage in search.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
